export const AUTH_SUCCESS = 'AUTH_SUCCESS'

